import {createResource, getResource} from "./common"

export type PaginatedResponse<T> = {
	data: T
	meta: {
		pagination: {
			totalItems: number
			limit: number
			offset: number
		}
	}
}

export type EmailTemplate = {
	type: "emailTemplate"
	id: string
	attributes: {
		subject: string
		htmlContent: string
		templateId: string
		version: number
		isPublished: boolean
		createdAt: Date
		updatedAt?: Date
		samples: string
	}
}

export type CreateEmailTemplateAttributes = {
	subject: string
	htmlContent: string
	templateId: string
	samples?: string
}

export type CreateEmailTemplateVersionAttributes = {
	subject: string
	htmlContent: string
	templateId: string
	forcePublish?: boolean
	samples?: string
}

export type PublishEmailTemplateVersionAttributes = {
	templateId: string
	version: number
}

export async function getEmailTemplatesList(
	accessToken: string,
	options?: {
		includeUnpublished?: boolean
		filterByTemplateId?: string
	}
) {
	const queryParams = new URLSearchParams()

	if (options?.includeUnpublished) {
		queryParams.append("filter[includeUnpublished]", "true")
	}

	if (options?.filterByTemplateId) {
		queryParams.append("filter[templateId]", options.filterByTemplateId)
	}

	const queryString = queryParams.toString() ? `?${queryParams.toString()}` : ""
	const result = await getResource<PaginatedResponse<EmailTemplate[]>>(`email-templates${queryString}`, accessToken)
	return result.map((v) => ({
		data: v.data,
		pagination: v.meta?.pagination,
	}))
}

export async function createEmailTemplate(accessToken: string, createAttributes: CreateEmailTemplateAttributes) {
	const result = await createResource<EmailTemplate>(`email-templates`, accessToken, {
		type: "emailTemplateCreateRequest",
		attributes: createAttributes,
	})
	return result.map((v) => v.data)
}

export async function createEmailTemplateVersion(
	accessToken: string,
	createAttributes: CreateEmailTemplateVersionAttributes
) {
	const result = await createResource<EmailTemplate>(`email-templates/createEmailTemplateVersion`, accessToken, {
		type: "emailTemplateCreateVersionRequest",
		attributes: createAttributes,
	})
	return result.map((v) => v.data)
}

export async function publishEmailTemplateVersion(
	accessToken: string,
	publishAttributes: PublishEmailTemplateVersionAttributes
) {
	const result = await createResource<EmailTemplate>(`email-templates/publishEmailTemplateVersion`, accessToken, {
		type: "publishEmailTemplateVersionRequest",
		attributes: publishAttributes,
	})
	return result.map((v) => v.data)
}
